
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-preapproved",
      function () {
        return require("private-next-pages/get-preapproved/index.tsx");
      }
    ]);
  